import React, { useEffect, useState } from "react";
import {
  GoogleMap,
  useJsApiLoader,
  Marker,
  InfoWindow,
} from "@react-google-maps/api";
import { useDispatch, useSelector } from "react-redux";
import { setSavedSelectedCart } from "../../redux/cartSlice";
import "./index.css";
import { useGetCartListByRestaurantIdQuery } from "../../redux/services/cartServise";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import Location from "../../assets/icons/location.PNG";
import { RESTAURANT_ID } from "../../constants/constans";
import icon from "../../assets/icons/cart.PNG";

const containerStyle = {
  width: "100%",
  height: "70vh",
};

const defaultCenter = {
  lat: 6.9270786,
  lng: 79.861243,
};

const libraries: ("places" | "geometry" | "marker")[] = [
  "places",
  "geometry",
  "marker",
];

export interface Locations {
  id: string;
  name: string;
  lat: number;
  lng: number;
  imageUrl: string;
  isFixedLocation: boolean;
}

export interface MapDetailsProps {
  isMapOpen: boolean;
  toggleMap: () => void;
}

const CartsLocationMap: React.FC<MapDetailsProps> = ({
  isMapOpen,
  toggleMap,
}) => {
  const dispatch = useDispatch();

  const restaurantId = RESTAURANT_ID;

  const iconURL =
    "https://storage.googleapis.com/fooddelivery-7eac6.appspot.com/Icons/cart-icon.png";

  const iconURL2 = icon;

  const [cartList, setCartList] = useState<any[]>([]);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [currentLocation, setCurrentLocation] =
    useState<google.maps.LatLngLiteral | null>(null);
  const { data } = useGetCartListByRestaurantIdQuery(restaurantId);

  const [locationList, setLocationList] = useState<Locations[]>([]);

  const [selectedCart, setSelectedCart] = useState<Locations | null>(null);

  const [localSelectedCart, setLocalSelectedCart] = useState<Locations | null>(
    null
  );

  const selectedSavedCart = useSelector(
    (state: any) => state.cartList.selectedCart
  );

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey:
      process.env.REACT_APP_GOOGLE_MAPS_API_KEY! ||
      "AIzaSyD_zEfLidcypXTaAVeiQVX5PHlrcj6xEpM",
    libraries,
  });

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        setCurrentLocation({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        });
      });
    }
  }, []);

  useEffect(() => {
    if (data && data?.carts) {
      setCartList(data.carts);
    }
  }, [data]);

  useEffect(() => {
    const filteredCartList = cartList.filter(
      (cart) => cart.cartState === "Online" && cart.status === "Approved"
    );
    if (cartList.length > 0) {
      const mappedLocations: Locations[] = filteredCartList.map(
        (cart: any) => ({
          id: cart.id,
          name: cart.displayName,
          lat: cart.location._latitude,
          lng: cart.location._longitude,
          imageUrl: cart.imageUrl,
          isFixedLocation: cart.isFixedLocation,
        })
      );
      setLocationList(mappedLocations);
    }
  }, [cartList]);

  const handleCartSave = () => {
    dispatch(setSavedSelectedCart(localSelectedCart));
    toggleMap();
  };

  const handleCartRemove = () => {
    dispatch(setSavedSelectedCart(null));
    setLocalSelectedCart(null);
    toggleMap();
  };

  if (!isLoaded) return <div></div>;

  return (
    <>
      <Modal
        isOpen={isMapOpen}
        toggle={toggleMap}
        size="lg"
        className="container-fluid"
        centered
      >
        <ModalHeader>
          <div className="d-flex flex-column text-center w-100">
            <h3>Choose Your Cart</h3>
          </div>
        </ModalHeader>

        <ModalBody className="p-0">
          <div className="mx-2 hide-on-large">
            <button
              onClick={handleCartRemove}
              className="d-flex btn btn-warning rounded text-light align-items-center mb-3 gap-2 px-3 py-2 hide-on-large"
            ></button>
          </div>

          <div
            className="p-1 border map-bg-color rounded map-container"
            style={{ height: "100%", width: "100%", padding: "30px" }}
          >
            {/* <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY!}> */}
            <GoogleMap
              mapContainerStyle={containerStyle}
              // center={currentLocation || defaultCenter}
              center={defaultCenter}
              zoom={14}
              options={{
                disableDefaultUI: false,
                clickableIcons: false,
                styles: []
              }}
            >
              {/* {currentLocation && (
                <Marker position={currentLocation} label="You" />
              )} */}
              {locationList.length > 0 &&
                locationList.map((cart: any, index: number) => (
                  <Marker
                    key={cart.id}
                    position={{
                      lat: cart.lat,
                      lng: cart.lng,
                    }}
                    icon={{
                      url: cart.isFixedLocation ? iconURL : iconURL2,
                      scaledSize: new window.google.maps.Size(40, 40),
                    }}
                    onClick={() => {
                      setLocalSelectedCart(cart);
                      // dispatch(setSavedSelectedCart(localSelectedCart));
                    }}
                    onMouseOver={() => {
                      setSelectedCart(cart);
                    }}
                  />
                ))}

              {selectedCart === null ? (
                <div></div>
              ) : (
                <InfoWindow
                  position={{ lat: selectedCart.lat, lng: selectedCart.lng }}
                  options={{
                    pixelOffset: new window.google.maps.Size(0, -40),
                  }}
                >
                  <div style={{ padding: "10px", maxWidth: "250px" }}>
                    <h5 style={{ marginBottom: "5px" }}>{selectedCart.name}</h5>
                  </div>
                </InfoWindow>
              )}
            </GoogleMap>
            {/* </LoadScript> */}
          </div>

          <div className="cart-selection mt-3">
            <div className="location-icon-container">
              <img
                src={Location}
                alt="Location Icon"
                className="location-icon"
              />
            </div>
            <span>
              {
                selectedSavedCart || localSelectedCart
                  ? `You have selected ${localSelectedCart?.name || selectedSavedCart?.name}`
                  : "Please select your preferred cart from the above map"
              }
            </span>
          </div>
          {/* 
          <button className="order-from-restaurant" onClick={handleCartRemove}>
            Order from Cart
          </button> */}

          <div className="button-container">
            <button className="model-close-button" onClick={toggleMap}>
              Close
            </button>
            <button
              className={`confirm-location-button ${!localSelectedCart?.id ? "disabled-button" : ""
                }`}
              onClick={handleCartSave}
              disabled={!localSelectedCart?.id}
            >
              Confirm Location
            </button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default CartsLocationMap;
